import React from 'react'
import { LinkButton } from '#app/components/buttons/link-button.tsx'
import { Trans, useTranslation } from 'react-i18next'

export default function SubscriptionProcessingRoute() {
	const { t } = useTranslation()
	const [isProcessing, setIsProcessing] = React.useState(true)

	React.useEffect(() => {
		const timer = setTimeout(() => {
			setIsProcessing(false)
		}, 6000)

		return () => clearTimeout(timer)
	}, [])

	return (
		<div className="bg-white pb-48">
			<div className="px-6 py-24 sm:py-32 lg:px-8">
				<div className="mx-auto max-w-4xl text-center">
					{isProcessing ? (
						<>
							<h2 className="text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
								{t('subscription.processing.title')}
							</h2>

							<p className="mt-6 text-lg text-gray-600">{t('subscription.processing.wait')}</p>

							{/* Optional spinner */}
							<div className="mt-10 flex justify-center">
								<div className="h-8 w-8 animate-spin rounded-full border-4 border-neutral-900 border-t-transparent" />
							</div>
						</>
					) : (
						<>
							<h2 className="text-balance text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
								{t('subscription.confirmed.title')}
							</h2>

							<p className="mx-auto mt-6 max-w-2xl text-lg text-gray-600">
								{t('subscription.confirmed.description')}
							</p>

							<div className="mt-10 flex items-center justify-center gap-x-6">
								<LinkButton path="/returns">{t('subscription.backToTaxReturns')}</LinkButton>
								<LinkButton path="/subscription">{t('subscription.confirmed.manage')}</LinkButton>
							</div>

							<p className="mx-auto mt-14 max-w-2xl text-gray-600">
								<Trans i18nKey="subscription.confirmed.footer" />
							</p>
						</>
					)}
				</div>
			</div>
		</div>
	)
}
